








import { UserStateModule } from '@/store';
import { FeedModel } from '@/type';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<FeedContentHeader>({})
export default class FeedContentHeader extends Vue {
  // PROPS
  @Prop({ type: Object, required: true })
  feed!: FeedModel.Read.Response.Feed;

  // MUTATIONS
  get getUserName() {
    return this.feed.member_id === UserStateModule.selfUser.member_id
      ? (dummy: any) => UserStateModule.selfUser.nickname
      : UserStateModule.getUserName;
  }
  get getAvaterSrc() {
    return this.feed.member_id === UserStateModule.selfUser.member_id
      ? (dummy: any) => UserStateModule.myImage
      : UserStateModule.getImage;
  }
  get feedPostedDateStr() {
    const { ymd, post_time } = this.feed;
    return `${ymd}T${post_time}`;
  }
}
